const routes = [{
  path: '/cameralist', // 摄像机设备列表页面入口
  name: 'cameralist',
  component: () => import('./pages/Home'),
  meta: {
    requireAuth: false
  },
  children: [
    {
      path: 'devicelist', // 摄像机设备列表页面
      name: 'devicelist',
      component: () => import('./pages/Index'),
      meta: {
        requireAuth: false,
        routerAlive: true,
      }
    },
    {
      path: 'gasList', // 可燃气体设备列表页面
      name: 'gasList',
      component: () => import('./pages/gasList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'cameralist'
      }
    },
    {
      path: 'devicelists', // 摄像机设备列表页面
      name: 'devicelists',
      component: () => import('./pages/DeviceList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'cameralist'
      }
    },
    {
      path: 'fireDeviceList', // 消防设备列表页面
      name: 'fireDeviceList',
      component: () => import('./pages/fireDeviceList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'cameralist'
      }
    },
    {
      path: 'fireTruckList', // 消防车设备列表页面
      name: 'fireTruckList',
      component: () => import('./pages/fireTruckList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'cameralist'
      }
    },
    {
      path: 'touchHelpList', //一键求救设备列表页面
      name: 'touchHelpList',
      component: () => import('./pages/touchHelpList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'cameralist'
      }
    },
    {
      path: 'drawConfig', // 图纸配置页面
      name: 'drawConfig',
      component: () => import('./components/drawConfig'),
      meta: {
        requireAuth: false,
      }
    },
    {
      path: 'deviceMap', // 设备位置绑定
      name: 'deviceMap',
      component: () => import('./components/deviceMap.vue'),
      meta: {
        requireAuth: false,
        module: 'cameralist'
      }
    },
    {
      path: 'operateConfig',
      name: 'operateConfig',
      component: () => import('./pages/operateConfig.vue'),
      meta: {
        requireAuth: false,
        module: 'cameralist'
      }
    },
    {
      // 电气火灾设备维护
      path: 'electricDeviceList',
      name: 'electricDeviceList',
      component: () => import('./pages/electricDeviceList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'cameralist'


      }
    },
    {
      // 电气火灾设备维护
      path: 'alarmDetailList',
      name: 'alarmDetailList',
      component: () => import('./pages/alarmDetailList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'cameralist'
      }
    },
    {
      // 其它设备维护
      path: 'otherDeviceList',
      name: 'otherDeviceList',
      component: () => import('./pages/otherDeviceList'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module: 'otherDeviceList'
      }
    }
    // {
    //   path: 'personTrafficList', // 人脸道闸列表页面
    //   name: 'personTrafficList',
    //   component: () => import('./pages/personTrafficList'),
    //   meta: {
    //     requireAuth: false
    //   }
    // }
  ]
},
  // {
  //   path: '/building', // 图纸配置页面
  //   name: 'building',
  //   component: () => import('./components/drawConfig'),
  //   meta: {
  //     requireAuth: false
  //   }
  // }
]

export default routes